/*
 * � 2020 Microsoft. All rights reserved.
 */

define('SolitaireShared/FreeCellLogic/FreeCellAuthority',[
        'lodash',
        'absolute/debug',
        'SolitaireShared/CardLogic/IGameAuthority',
        'SolitaireShared/CardLogic/TipEventArgs',
        'SolitaireShared/CardLogic/Supply',
        'SolitaireShared/CardLogic/Card',
        'SolitaireShared/CardLogic/Pile',
        'SolitaireShared/CardLogic/CardValue',
        'SolitaireShared/CardLogic/CardSuit',
        'SolitaireShared/CardLogic/CardColor',
        'SolitaireShared/CardLogic/CardOp',
        'SolitaireShared/CardLogic/CardAction',
        'SolitaireShared/CardLogic/MoveState',
        'SolitaireShared/CardLogic/DealData',
        'SolitaireShared/FreeCellLogic/FreecellRandom'],
    function (_, Debug, IGameAuthority, TipEventArgs, Supply, Card, Pile, CardValue, CardSuit, CardColor, CardOp, CardAction, MoveState, DealData, FreecellRandom) {
    "use strict";

        var FreeCellAuthority = function () {
            this.initFreeCellAuthority();
        };

        FreeCellAuthority.constructor = FreeCellAuthority;
        FreeCellAuthority.prototype = Object.create(IGameAuthority.prototype);

        FreeCellAuthority.prototype.initFreeCellAuthority = function () {
            this.CardSupply = new Supply("FreeCell");
            this.CardSupply.Authority = this;

            this.MaxCardsInCells = 0;
            this.MaxCardsInTableau = 0;

            this.IsChallenge = false;
            this.MAX_DEALS = 0;

            this._lastHint;

            this.DealScript = FreeCellAuthority.DefaultDealScript;

            this.WinSetAction = null;
            this.preventAutoMove = false;
        };


               /* public event OnTipEventHandler OnTip;
                public event OnBonusEffectEventHandler OnBonusEffect;
                public event OnAuthorityDealEventHanlder OnDealEvent;*/

        FreeCellAuthority.prototype.Setup = function ()
        {
            this.CardSupply.AddPile("Stock", "Stock");

            this.CardSupply.AddPile("Foundation0", "Foundation");
            this.CardSupply.AddPile("Foundation1", "Foundation");
            this.CardSupply.AddPile("Foundation2", "Foundation");
            this.CardSupply.AddPile("Foundation3", "Foundation");

            this.CardSupply.AddPile("Free0", "Free");
            this.CardSupply.AddPile("Free1", "Free");
            this.CardSupply.AddPile("Free2", "Free");
            this.CardSupply.AddPile("Free3", "Free");

            this.CardSupply.AddPile("Tableau0", "Tableau");
            this.CardSupply.AddPile("Tableau1", "Tableau");
            this.CardSupply.AddPile("Tableau2", "Tableau");
            this.CardSupply.AddPile("Tableau3", "Tableau");
            this.CardSupply.AddPile("Tableau4", "Tableau");
            this.CardSupply.AddPile("Tableau5", "Tableau");
            this.CardSupply.AddPile("Tableau6", "Tableau");
            this.CardSupply.AddPile("Tableau7", "Tableau");

            this.CardSupply.CreateCards(1, 4, 0);
        };

        FreeCellAuthority.prototype.Reset = function ()
        {
            this.MaxCardsInCells = 0;
            this.MaxCardsInTableau = 0;
            this.CardSupply.ResetGame();
        };

        FreeCellAuthority.prototype.BoardsCompleted = function () { return -1; };

        FreeCellAuthority.prototype.NumDealsLeft = function () { return 0; };

        FreeCellAuthority.prototype.UsesClassicSeeds = function (deckseed)
        {
            return (deckseed != null && deckseed.indexOf("$") == 0);
        };

        FreeCellAuthority.prototype.Deal = function (seedOverride)
        {
            try
            {
                // move all the cards to the root pile and reset score/time to 0
                this.CardSupply.PrepareGame();

                if (this.CardSupply.CardAnimator != null)
                {
                    this.CardSupply.CardAnimator.BeginShuffleAnimation();
                }

                if(seedOverride) {
                    this.CardSupply.DeckSeed = seedOverride;
                }
                else if (this.CardSupply.DeckSeed == null)
                {
                    //this.CardSupply.DeckSeed = "$" + Math.round(rnd * 9999999); // TODO - is this correct?
                    if (this.CardSupply.Options.DIFFICULTY && this.CardSupply.Options.DIFFICULTY !== "RANDOM") {
                        this.CardSupply.DeckSeed = "$" + this.CardSupply.GetBakedInDeckSeed();
                    } else {
                        var rnd = Math.random();
                        this.CardSupply.DeckSeed = "$" + Math.round(rnd * 9999999); // TODO - is this correct?
                    }
                }

                // shuffle the root pile
                if (this.UsesClassicSeeds(this.CardSupply.DeckSeed))
                {
                    var seed = parseInt(this.CardSupply.DeckSeed.substring(1));

                    if (!isNaN(seed))
                    {
                        var cardOrder = FreecellRandom.GetDeal(seed);

                        this.CardSupply.ClearCardList();
                        this.CardSupply.RootPile.ClearCards();
                        for (var i = 51; i >= 0; i--)
                        {
                            var card = new Card(this.CardSupply, cardOrder[i].Key, cardOrder[i].Value, 0, i);
                            this.CardSupply.GetCardList().push(card);
                            this.CardSupply.RootPile.ForceAdd(card);
                        }
                    }
                    else
                    {
                        return false;
                    }
                }
                else
                {
                    this.CardSupply.DeckSeed = this.CardSupply.RootPile.Shuffle(this.CardSupply.DeckSeed);
                }

                this.CardSupply.OnShuffleCards();

                // Deal out the cards
                CardAction.RunActions(this.CardSupply, this.DealScript);

                // Start the game
                this.CardSupply.StartGame();
            }
            catch (e)
            {
                Debug.log(e);
                //System.Diagnostics.Debug.WriteLine("Exception: {0}", e);
                return false;
            }
            return true;
        };

        FreeCellAuthority.prototype.Tick = function (playedTime)
        {
        };

        FreeCellAuthority.prototype.NumEmptyFreeCells = function ()
        {
            var count = 0;

            if (this.CardSupply.GetPile("Free0").Empty) count++;
            if (this.CardSupply.GetPile("Free1").Empty) count++;
            if (this.CardSupply.GetPile("Free2").Empty) count++;
            if (this.CardSupply.GetPile("Free3").Empty) count++;

            return count;
        };

        FreeCellAuthority.prototype.MaxTableauSize = function ()
        {
            var maxCards = 0;
            for (var i=0; i<=7; ++i)
            {
                maxCards = Math.max(maxCards, this.CardSupply.GetPile("Tableau" + i).Count);
            }
            return maxCards;
        };

        FreeCellAuthority.prototype.NumEmptyTableaus = function ()
        {
            var count = 0;

            if (this.CardSupply.GetPile("Tableau0").Empty) count++;
            if (this.CardSupply.GetPile("Tableau1").Empty) count++;
            if (this.CardSupply.GetPile("Tableau2").Empty) count++;
            if (this.CardSupply.GetPile("Tableau3").Empty) count++;
            if (this.CardSupply.GetPile("Tableau4").Empty) count++;
            if (this.CardSupply.GetPile("Tableau5").Empty) count++;
            if (this.CardSupply.GetPile("Tableau6").Empty) count++;
            if (this.CardSupply.GetPile("Tableau7").Empty) count++;

            return count;
        };

        FreeCellAuthority.prototype.CanMoveCards = function (srcPile, dstPile, numToBeMoved, triggerTips)
        {
            triggerTips = !!triggerTips;

            if (numToBeMoved == 1)
                return true; // you can always move 1 card

            var EmptyTableaus = (this.NumEmptyTableaus() - (dstPile != null && dstPile.Empty ? 1 : 0));
            var MaxNumToBeMoved =
            (this.NumEmptyFreeCells() + 1) * Math.round(Math.pow(2.0, EmptyTableaus));

            if (srcPile.Count < numToBeMoved || numToBeMoved < 1)
                return false;

            if (numToBeMoved > MaxNumToBeMoved)
            {
                if (triggerTips && this.OnTip != null)
                {
                    if (MaxNumToBeMoved <= 1)
                        this.OnTip(this, new TipEventArgs("Tips_FreeCell_InsufficientFreeSpace_Singular", [ numToBeMoved.toString(), MaxNumToBeMoved.toString() ]));
                else
                    this.OnTip(this , new TipEventArgs("Tips_FreeCell_InsufficientFreeSpace_Plural", [ numToBeMoved.toString(), MaxNumToBeMoved.toString() ]));
                }

                return false;
            }

            return this.CanPickupCards(srcPile, dstPile, numToBeMoved, triggerTips);
        };

        FreeCellAuthority.prototype.CanPickupCards = function (srcPile, dstPile, numToBeMoved, triggerTips)
        {
            if (srcPile.Count < numToBeMoved || numToBeMoved < 1)
                return false;

            if (numToBeMoved > 1)
            {
                var prev = srcPile.NthFromTop(numToBeMoved);
                for (var i = numToBeMoved - 1; i > 0; i--)
                {
                    var card = srcPile.NthFromTop(i);

                    if (card.Color == prev.Color || card.Color == CardColor.None || prev.Color == CardColor.None)
                    {
                        if (triggerTips && this.OnTip != null)
                            this.OnTip(this, new TipEventArgs("Tips_FreeCell_MoveCards"));

                        return false;
                    }

                    if (prev.ValueNum != card.ValueNum + 1)
                    {
                        if (triggerTips && this.OnTip != null)
                            this.OnTip(this, new TipEventArgs("Tips_FreeCell_MoveCards"));

                        return false;
                    }

                    prev = card;
                }
            }

            return true;
        };

        FreeCellAuthority.prototype.TableauCanTakeCard = function (tableau, card, triggerTips)
        {
            triggerTips = !!triggerTips;

            if (tableau == null || card == null)
                return false;

            if (card.Value == CardValue.Values.Joker)
                return false;

            if (tableau.Empty)
                return true;

            if (card.Color == tableau.Top.Color)
            {
                if (triggerTips && this.OnTip != null)
                    this.OnTip(this, new TipEventArgs("Tips_SameColor"));

                return false;
            }

            if (tableau.Top.ValueNum != card.ValueNum + 1)
            {
                if (triggerTips && this.OnTip != null)
                    this.OnTip(this, new TipEventArgs("Tips_OutOfOrder"));

                return false;
            }

            if (card.Color != CardColor.None && tableau.Top.Color != CardColor.None)
            {
                return true;
            }

            return false;
        };

        FreeCellAuthority.prototype.FoundationCanTakeCard = function (foundation, card, triggerTips)
        {
            triggerTips = !!triggerTips;

            if (foundation == null || card == null)
                return false;

            if (card.Value == CardValue.Values.Joker)
                return false;

            if (this.DoesFoundationSuitMatchCard(foundation, card))
            {
                if (foundation.Empty && card.Value == CardValue.Values.Ace)
                {
                    return true;
                }
                if (!foundation.Empty && card.ValueNum == foundation.Top.ValueNum + 1)
                {
                    return true;
                }
            }
            if (triggerTips && this.OnTip != null)
            {
                this.OnTip(this, new TipEventArgs("Tips_FoundationPile"));
            }

            return false;
        };

        FreeCellAuthority.prototype.DoesFoundationSuitMatchCard = function (pile, card)
        {
            switch (pile.Name)
            {
                case "Foundation0":
                    return (card.Suit == CardSuit.Hearts);
                case "Foundation1":
                    return (card.Suit == CardSuit.Clubs);
                case "Foundation2":
                    return (card.Suit == CardSuit.Diamonds);
                case "Foundation3":
                    return (card.Suit == CardSuit.Spades);
                default:
                    return false;
            }
        };

        FreeCellAuthority.prototype.GetFoundationForCard = function (card)
        {
            switch (card.Suit)
            {
                case CardSuit.Hearts:
                    return this.CardSupply.GetPile("Foundation0");
                case CardSuit.Clubs:
                    return this.CardSupply.GetPile("Foundation1");
                case CardSuit.Diamonds:
                    return this.CardSupply.GetPile("Foundation2");
                default:
                    return this.CardSupply.GetPile("Foundation3");
            }
        };

        FreeCellAuthority.prototype.IsActionAllowed = function (action, triggerTips)
        {
            if (action == null || action.Ops == null || action.Ops.length == 0)
                return false;

            var op = action.Ops[0];
            if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Undo)
            {
                // always allow an undo by itself
                return true;
            }

            if (action.IsNoop())
            {
                // always allow a no-op action
                return true;
            }

            if (action.Ops.length == 1 && op.Opcode == CardOp.Op.Game)
            {
                // always allow the game to be started
                return true;
            }

            if (op.Opcode == CardOp.Op.Move)
            {
                var sourcePile = op.GetPile(CardOp.eMoveParams.SourcePile);
                var destPile = op.GetPile(CardOp.eMoveParams.DestPile);
                var numCards = op.GetNumber(CardOp.eMoveParams.NumCards);

                if (action.Ops.length == 1)
                {
                    if (sourcePile.Type == "Tableau" && destPile.Type == "Tableau")
                    {
                        if (numCards >= 1 &&
                            sourcePile.Count >= numCards &&
                            this.TableauCanTakeCard(destPile, sourcePile.NthFromTop(numCards), triggerTips) &&
                            this.CanMoveCards(sourcePile, destPile, numCards, triggerTips))
                        {
                            return true;
                        }
                    }
                    else if (sourcePile.Type == "Tableau" && destPile.Type == "Free")
                    {
                        if (numCards == 1 &&
                            sourcePile.Count >= numCards &&
                            destPile.Empty)
                        {
                            return true;
                        }
                    }
                    else if (sourcePile.Type == "Tableau" && destPile.Type == "Foundation")
                    {
                        if (numCards == 1 &&
                            sourcePile.Count >= numCards &&
                            this.FoundationCanTakeCard(destPile, sourcePile.Top, triggerTips))
                        {
                            return true;
                        }
                    }
                    else if (sourcePile.Type == "Free" && destPile.Type == "Foundation")
                    {
                        if (numCards == 1 &&
                            sourcePile.Count >= numCards &&
                            this.FoundationCanTakeCard(destPile, sourcePile.Top, triggerTips))
                        {
                            return true;
                        }
                    }
                    if (sourcePile.Type == "Free" && destPile.Type == "Tableau")
                    {
                        if (numCards >= 1 &&
                            !sourcePile.Empty &&
                            this.TableauCanTakeCard(destPile, sourcePile.Top, triggerTips))
                        {
                            return true;
                        }
                    }
                }
            }

            return false;
        };

        FreeCellAuthority.prototype.CanAutoSolve = function ()
        {
            return false;
        };

        FreeCellAuthority.prototype.CanKeyboardFocusCard = function (card)
        {
            return this.CanPickupCard(card);
        };

        FreeCellAuthority.prototype.CanPickupCard = function (card)
        {
            if (this.CardSupply.WaitingForBlockingAnimation)
                return false;

            if (card.Pile.Type == "Free")
                return true;

            if (card.Pile.Type == "Tableau")
            {
                var pos = card.Pile.GetCardPosFromEnd(card);
                if (this.CanPickupCards(card.Pile, null, pos, false))
                    return true;
            }

            return false;
        };

        FreeCellAuthority.prototype.CanAcceptCards = function (pile)
        {
            if (pile.Type == "Foundation" || pile.Type == "Tableau")
                return true;

            if (pile.Type == "Free" && pile.Empty)
                return true;

            return false;
        };

        FreeCellAuthority.prototype.IsGameWon = function ()
        {
            if (this.CardSupply.WaitingForAnimation)
            {
                // We don't win unless the card animation is finished.
                return false;
            }
            return this.CheckWin();
        };

        FreeCellAuthority.prototype.CheckWin = function ()
        {
            if (this.GetCompletedStacks() == 4)
                return true;

            return false;
        };

        FreeCellAuthority.prototype.GetScoreForAction = function (action)
        {
            for (var i = 0; i < action.Ops.length; i++)
            {
                var op = action.Ops[i];

                if (op.Opcode == CardOp.Op.Move &&
                    op.GetPile(CardOp.eMoveParams.DestPile).Type == "Foundation")
                {
                    return 250;
                }
                if (op.Opcode == CardOp.Op.Undo)
                {
                    return -100 * op.GetNumber(CardOp.eUndoParams.NumMovesUndone);
                }
            }

            return 0;
        };

        FreeCellAuthority.prototype.GetScoreForTimer = function (currTimer, prevTimer)
        {
            return 0;
        };

        FreeCellAuthority.prototype.GetStartingTime = function ()
        {
            return 0;
        };

        FreeCellAuthority.prototype.GetCompletedStacks = function ()
        {
            var completedStacks = 0;

            if (this.CardSupply.GetPile("Foundation0").Count == 13)
                completedStacks++;
            if (this.CardSupply.GetPile("Foundation1").Count == 13)
                completedStacks++;
            if (this.CardSupply.GetPile("Foundation2").Count == 13)
                completedStacks++;
            if (this.CardSupply.GetPile("Foundation3").Count == 13)
                completedStacks++;

            return completedStacks;
        };

        FreeCellAuthority.prototype.GetBonusScore = function (totalTimer)
        {
            return 0;
        };

        FreeCellAuthority.prototype.GetMaxScore = function ()
        {
            return Number.MAX_VALUE;
        };

        FreeCellAuthority.prototype.GetMinScore = function ()
        {
            return 0;
        };

        FreeCellAuthority.prototype.GetStartingScore = function ()
        {
            return 0;
        };



        FreeCellAuthority.prototype.GetHint = function (cycle)
        {
            cycle = !!cycle;
            return this.GetHintInternal(cycle);
        };

        FreeCellAuthority.prototype.GetHintInternal = function (cycle)
            {
                cycle = !!cycle;

                var numTableaus = 8;
                var numFoundations = 4;
                var numFrees = 4;

                var hints = [];

                var source, destination;

                // Step 1: What card value are we looking to place on the foundation next?
                var targetCardValue = CardValue.Values.King;
                for (var i = 0; i < numFoundations; i++)
                {
                    source = this.CardSupply.GetPile("Foundation" + i);
                    if (source.Empty)
                    {
                        targetCardValue = CardValue.Values.Ace;
                        break;
                    }
                    if (source.Top.Value < targetCardValue)
                    {
                        targetCardValue = source.Top.Value;
                    }
                }

                if (!cycle && hints.length > 0)
                    return hints[0];

                // Step 2: See if we can move the target value from free -> foundation
                for (var i = 0; i < numFrees; i++)
                {
                    source = this.CardSupply.GetPile("Free" + i);
                    if (!source.Empty && source.Top.Value == targetCardValue)
                    {
                        destination = this.GetFoundationForCard(source.Top);

                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", source.Name, destination.Name, "1" ];
                        hint.Parse(args, 0);
                        hints.push(hint);
                    }
                }

                if (!cycle && hints.length > 0)
                    return hints[0];

                // Step 3: See if we can move the target value from the top of a tableau -> foundation
                for (var i = 0; i < numTableaus; i++)
                {
                    source = this.CardSupply.GetPile("Tableau" + i);
                    if (!source.Empty && source.Top.Value == targetCardValue)
                    {
                        destination = this.GetFoundationForCard(source.Top);

                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", source.Name, destination.Name, "1" ];
                    hint.Parse(args, 0);
                    hints.push(hint);
                }
            }

            if (!cycle && hints.length > 0)
                return hints[0];

            // Step 4: Try to move free -> tableau
            for (var i = 0; i < numFrees; i++)
            {
                source = this.CardSupply.GetPile("Free" + i);
                if (source.Empty)
                    continue;

                // Check if we can move the entire consecutive run on this tableau.
                for (var j = 0; j < numTableaus; j++)
                {
                    var card = source.Top;

                    destination = this.CardSupply.GetPile("Tableau" + j);
                    if (this.TableauCanTakeCard(destination, card) && this.CanMoveCards(source, destination, 1))
                    {
                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", source.Name, destination.Name, "1" ];
                    hint.Parse(args, 0);
                    hints.push(hint);
                }
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Step 5: Try to move tableau -> tableau
        for (var i = 0; i < numTableaus; i++)
        {
            source = this.CardSupply.GetPile("Tableau" + i);
            if (source.Empty)
                continue;

            // Check if we can move the entire consecutive run on this tableau.
            for (var j = 1; j <= source.Count; j++)
            {
                if (!this.CanMoveCards(source, null, j))
                    break;

                var sourceBottom = source.NthFromTop(j);

                for (var k = 0; k < numTableaus; k++)
                {
                    if (i == k)
                        continue;

                    destination = this.CardSupply.GetPile("Tableau" + k);
                    if (this.TableauCanTakeCard(destination, sourceBottom) && this.CanMoveCards(source, destination, j))
                    {
                        var hint = new CardOp(this.CardSupply);
                        var args = [ "MOVE", source.Name, destination.Name, j.toString() ];
                        hint.Parse(args, 0);
                        hints.push(hint);
                    }
                }
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Step 6: Try to move tableau -> foundation
        for (var i = 0; i < numTableaus; i++)
        {
            source = this.CardSupply.GetPile("Tableau" + i);
            if (source.Empty)
                continue;

            for (var j = 0; j < numFoundations; j++)
            {
                destination = this.CardSupply.GetPile("Foundation" + j);
                if (this.FoundationCanTakeCard(destination, source.Top))
                {
                    var hint = new CardOp(this.CardSupply);
                    var args = [ "MOVE", source.Name, destination.Name, "1" ];
                    hint.Parse(args, 0);
                    hints.push(hint);
                }
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];

        // Step 7: Try to move tableau -> free
        // Find a free cell
        var freecell = null;
        for (var i = 0; i < 4; i++)
        {
            destination = this.CardSupply.GetPile("Free" + i);
            if (destination.Empty)
            {
                freecell = destination;
                break;
            }
        }
        // If there is a free cell
        if (freecell != null)
        {
            // Find the tableau with a card of value 'valueToFind' closest to the top
            var minDepthPile = null;
            var minValuePosition = Number.MAX_VALUE;
            for (var i = 0; i < numTableaus; i++)
            {
                source = this.CardSupply.GetPile("Tableau" + i);
                if (source.Empty)
                    continue;

                // Find the minimum position of card with value 'valueToFind' in tableau
                for (var j = 1; j <= source.Count; j++)
                {
                    var nth = source.NthFromTop(j);
                    if (nth.Value == targetCardValue && j < minValuePosition)
                    {
                        minDepthPile = source;
                        minValuePosition = j;
                        break;
                    }
                }
            }
            if (minDepthPile != null)
            {
                var hint = new CardOp(this.CardSupply);
                var args = [ "MOVE", minDepthPile.Name, freecell.Name, "1" ];
                hint.Parse(args, 0);
                hints.push(hint);
            }
        }

        if (!cycle && hints.length > 0)
            return hints[0];



        if (hints.length > 0)
        {
            if (!cycle)
            {
                return hints[0];
            }
            else if (cycle)
            {
                if (this._lastHint != null)
                {
                    // Find the position of the last hint in the hint list (if possible).
                    var index;
                    for (index = 0; index < hints.length; index++)
                    {
                        if (hints[index].Equals(this._lastHint))
                            break;
                    }

                    if (index >= hints.length - 1)
                    {
                        var hint = hints[0];
                        this._lastHint = hint;
                        return hint;
                    }
                    else
                    {
                        var hint = hints[index + 1];
                        this._lastHint = hint;
                        return hint;
                    }
                }
                else
                {
                    var hint = hints[0];
                    this._lastHint = hint;
                    return hint;
                }
            }
        }

        return new CardOp(this.CardSupply);
    };

    FreeCellAuthority.prototype.GetCardHint = function (card) {
        var i, dest, tableauCount = 8, freeCount = 4, src = card.Pile,
            srcPos = parseInt(src.Name[src.Name.length - 1]),
            cardPos = src.GetCardPosFromEnd(card),
            cardPosStr = cardPos.toString(),
            hint = new CardOp(this.CardSupply);
        if (card.Pile.Type === "Free") {
            // Free to Foundation
            dest = this.GetFoundationForCard(card);
            if (this.FoundationCanTakeCard(dest, card)) {
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
            // Free to Tableau
            for (i = 0; i < tableauCount; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card)) continue;
                if (!this.CanMoveCards(src, dest, cardPos)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
        } else if (card.Pile.Type === "Tableau") {
            // Tableau to Foundation
            dest = this.GetFoundationForCard(card);
            if (cardPos === 1 && this.FoundationCanTakeCard(dest, card)) {
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
            // Tableau to Tableau: from src pile's next neighbor to the end
            for (i = (srcPos + 1); i < tableauCount; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card, false)) continue;
                if (!this.CanMoveCards(src, dest, cardPos)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
            // Tableau to Tableau: from the start to the src pile's previous neighbor
            for (i = 0; i < srcPos; i++) {
                dest = this.CardSupply.GetPile("Tableau" + i);
                if (!this.TableauCanTakeCard(dest, card, false)) continue;
                if (!this.CanMoveCards(src, dest, cardPos)) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
            // Tableau to Free
            if (cardPos !== 1) return;
            for (i = 0; i < freeCount; i++) {
                dest = this.CardSupply.GetPile("Free" + i);
                if (!dest.Empty) continue;
                hint.Parse(["MOVE", src.Name, dest.Name, cardPosStr], 0);
                return hint;
            }
        }
    };

    /// <summary>
    /// FreeCell auto moves are conservative, e.g. the game won't move an open 3H
    /// onto a foundation if still exists 2S or 2C on a tableau. So we use the top
    /// cards of each foundation to check this condition for any potential auto moves.
    /// </summary>
    /// <param name="card"></param>
    /// <returns></returns>
    FreeCellAuthority.prototype.SafeToMoveToFoundation = function (card)
    {
        if(this.preventAutoMove) {
            this.preventAutoMove = false;
            return false;
        }

        if (card.Value == CardValue.Values.Ace || card.Value == CardValue.Values.Two)
            return true;

        var numFoundations = 4;

        var safeSuits = 0;

        for (var i = 0; i < numFoundations; i++)
        {
            var f = this.CardSupply.GetPile("Foundation" + i).Top;
            if (f != null && f.Color != card.Color && f.ValueNum >= card.ValueNum - 1)
                safeSuits++;
        }

        return safeSuits == 2;
    };

    FreeCellAuthority.prototype.GetAutomaticMove = function ()
    {
        if (this.IsGameWon() || this.CurrentMoveState() == MoveState.NoMovesLeft) return null;
        var numTableaus = 8;
        var numFoundations = 4;
        var numFreeCells = 4;

        var source, destination;

        // Tableau-a-foundation.
        for (var i = 0; i < numTableaus; i++)
        {
            source = this.CardSupply.GetPile("Tableau" + i);
            /*if (source.Empty || (source.Top.Value == CardValue.Values.Ace && IsFull(i))) // Don't auto-move top-level aces.
             continue;*/

            for (var j = 0; j < numFoundations; j++)
            {
                destination = this.CardSupply.GetPile("Foundation" + j);
                if (this.FoundationCanTakeCard(destination, source.Top) && this.SafeToMoveToFoundation(source.Top))
                {
                    var move = new CardAction(this.CardSupply);
                    var args = [ "MOVE", source.Name, destination.Name, "1" ];
                    move.Parse(args, 0);
                    move.autoMove = true;
                    return move;
                }
            }
        }

        // Free-a-foundation.
        for (var i = 0; i < numFreeCells; i++)
        {
            source = this.CardSupply.GetPile("Free" + i);
            if (source.Empty)
                continue;

            for (var j = 0; j < numFoundations; j++)
            {
                destination = this.CardSupply.GetPile("Foundation" + j);
                if (this.FoundationCanTakeCard(destination, source.Top) && this.SafeToMoveToFoundation(source.Top))
                {
                    var move = new CardAction(this.CardSupply);
                    var args = [ "MOVE", source.Name, destination.Name, "1" ];
                    move.Parse(args, 0);
                    move.autoMove = true;
                    return move;
                }
            }
        }

        return null;
    };



    FreeCellAuthority.prototype.CurrentMoveState = function ()
    {
        if (this.CardSupply.WaitingForAnimation || this.IsGameWon())
            return MoveState.CanMove;

        // TODO Check for simple move cycles in an otherwise unwinnable game?

        // A player still has a move if...
        var numTableaus = 8;
        var numFoundations = 4;
        var numFree = 4;

        var pile;

        // TODO REMOVE DEBUG. for creating easy loss scenario in the worst solitaire game ever invented
        /*var filledCount = 0;
        for (var i = 0; i < numFoundations; i++)
        {
            pile = this.CardSupply.GetPile("Foundation" + i);
            if (pile.Count >= 1)
                filledCount ++
        }
        if(filledCount == numFoundations) {
            return MoveState.NoMovesLeft;
        }*/
        // TODO REMOVE DEBUG


        // 1. There is an open free cell.
        for (var i = 0; i < numFree; i++)
        {
            pile = this.CardSupply.GetPile("Free" + i);
            if (pile.Count == 0)
                return MoveState.CanMove;
        }

        // 2. There are any open tableaus.
        for (var i = 0; i < numTableaus; i++)
        {
            pile = this.CardSupply.GetPile("Tableau" + i);
            if (pile.Count == 0)
                return MoveState.CanMove;
        }

        // 3. A card can be moved from a tableau to a foundation.
        for (var i = 0; i < numTableaus; i++)
        {
            pile = this.CardSupply.GetPile("Tableau" + i);
            if (pile.Empty)
                continue;

            for (var j = 0; j < numFoundations; j++)
            {
                if (this.FoundationCanTakeCard(this.CardSupply.GetPile("Foundation" + j), pile.Top))
                    return MoveState.CanMove;
            }
        }

        // 4. A card can be moved from a tableau to another tableau.
        for (var i = 0; i < numTableaus; i++)
        {
            pile = this.CardSupply.GetPile("Tableau" + i);
            if (pile.Empty)
                continue;

            for (var j = 0; j < numTableaus; j++)
            {
                if (this.TableauCanTakeCard(this.CardSupply.GetPile("Tableau" + j), pile.Top))
                    return MoveState.CanMove;
            }
        }

        // 5. A card can be moved from free -> tableau
        for (var i = 0; i < numFree; i++)
        {
            pile = this.CardSupply.GetPile("Free" + i);
            if (pile.Empty)
                continue;

            for (var j = 0; j < numTableaus; j++)
            {
                if (this.TableauCanTakeCard(this.CardSupply.GetPile("Tableau" + j), pile.Top))
                    return MoveState.CanMove;
            }
        }
        // 6. A card can be moved from free -> foundation
        for (var i = 0; i < numFree; i++)
        {
            pile = this.CardSupply.GetPile("Free" + i);
            if (pile.Empty)
                continue;

            for (var j = 0; j < numFoundations; j++)
            {
                if (this.FoundationCanTakeCard(this.CardSupply.GetPile("Foundation" + j), pile.Top))
                    return MoveState.CanMove;
            }
        }

        return MoveState.NoMovesLeft;
    };

    FreeCellAuthority.prototype.ResetNoMoreMovesState = function ()
    {
        // Do nothing.
    };

    FreeCellAuthority.prototype.TriggerTip = function (/* TipEventArgs */ e)
    {
        if (this.OnTip != null)
            this.OnTip(this, e);
    };

    FreeCellAuthority.prototype.OnRunAction = function (action, undo, triggerTips)
    {
        this.MaxCardsInCells = Math.max(this.MaxCardsInCells, 4 - this.NumEmptyFreeCells());
        this.MaxCardsInTableau = Math.max(this.MaxCardsInTableau, this.MaxTableauSize());

        // prevent automove from occuring if this is an undo and previous was auto generated
        if(undo && action.autoMove) {
            this.preventAutoMove = true;
        } else if (action.Ops[0].OpName  !== 'noop') {
            this.preventAutoMove = false;
        }

    };

    FreeCellAuthority.prototype.OnRunSpecialAction = function (tag, undo)
    {
    };

    FreeCellAuthority.prototype.OnGameOver = function (fullActionList, collapsedActionList)
    {

    };

    FreeCellAuthority.prototype.LaunchOptInAds = function ()
    {

    };

    FreeCellAuthority.prototype.GenerateDealData = function ()
    {
        var i, res;
        var cardIndex = 0;

        var script = "";
        var deck = new Array(this.CardSupply.Count);

        for (i = 3; i >= 0; i--)
        {
            res = this.ProcessDealDataForPile("Foundation" + i, deck, script, cardIndex);
            deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        }
        for (i = 3; i >= 0; i--)
        {
            res = this.ProcessDealDataForPile("Free" + i, deck, script, cardIndex);
            deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        }
        for (i = 7; i >= 0; i--)
        {
            res = this.ProcessDealDataForPile("Tableau" + i, deck, script, cardIndex);
            deck = res.deck; script = res.script; cardIndex = res.cardIndex;
        }

        script = "BEGIN " + script + "END";
        return new DealData(Pile.ConstructSeedFromDeck(deck, this.CardSupply.Count).ToString(), script);
    };

    /// <summary>
    /// opt in ads extra deals
    /// </summary>
    /// <param name="dealsCnt"></param>
    /// <param name="logAction"> </param>
    FreeCellAuthority.prototype.AddExtraDeals = function (dealsCnt, logAction)
    {
        //do nothing for FreeCell
    };

    FreeCellAuthority.prototype.AddWildCard = function (logAction)
    {
        //no wild cards for free cell
    };

    FreeCellAuthority.prototype.ApplyCurrentOptInAdBonus = function (bonusType)
    {
        //not bonuses for free cell
    };

    FreeCellAuthority.prototype.ProcessDealDataForPile = function (pileName, deck, script, currentIndex)
    {
        var currentPile = this.CardSupply.GetPile(pileName);

        if (currentPile != null && !currentPile.Empty)
        {
            _.forEach (currentPile.GetCards(), function (card)
            {
                deck[currentIndex++] = card.Sequence;
            });
            script = "MOVE Root " + pileName + " " + currentPile.Count + " " + script;
        }
        return {deck: deck, script: script, currentIndex: currentIndex};
    };

    FreeCellAuthority.prototype.ForceDealScript = function (script)
    {
        this.DealScript = (script != null ? script : FreeCellAuthority.DefaultDealScript);
    };


    FreeCellAuthority.DefaultDealScript =
        "BEGIN " +
        "MOVE Root Stock 52 " +

        "MOVE Stock Tableau0 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau3 1 " +
        "MOVE Stock Tableau4 1 " +
        "MOVE Stock Tableau5 1 " +
        "MOVE Stock Tableau6 1 " +
        "MOVE Stock Tableau7 1 " +

        "MOVE Stock Tableau7 1 " +
        "MOVE Stock Tableau6 1 " +
        "MOVE Stock Tableau5 1 " +
        "MOVE Stock Tableau4 1 " +
        "MOVE Stock Tableau3 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau0 1 " +

        "MOVE Stock Tableau0 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau3 1 " +
        "MOVE Stock Tableau4 1 " +
        "MOVE Stock Tableau5 1 " +
        "MOVE Stock Tableau6 1 " +
        "MOVE Stock Tableau7 1 " +

        "MOVE Stock Tableau7 1 " +
        "MOVE Stock Tableau6 1 " +
        "MOVE Stock Tableau5 1 " +
        "MOVE Stock Tableau4 1 " +
        "MOVE Stock Tableau3 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau0 1 " +

        "MOVE Stock Tableau0 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau3 1 " +
        "MOVE Stock Tableau4 1 " +
        "MOVE Stock Tableau5 1 " +
        "MOVE Stock Tableau6 1 " +
        "MOVE Stock Tableau7 1 " +

        "MOVE Stock Tableau7 1 " +
        "MOVE Stock Tableau6 1 " +
        "MOVE Stock Tableau5 1 " +
        "MOVE Stock Tableau4 1 " +
        "MOVE Stock Tableau3 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau0 1 " +

        "MOVE Stock Tableau0 1 " +
        "MOVE Stock Tableau1 1 " +
        "MOVE Stock Tableau2 1 " +
        "MOVE Stock Tableau3 1 " +
        "END";

        return FreeCellAuthority;
});

